export default __webpack_public_path__ + "static/media/inbox.b6aec2d5.svg";